import { render, staticRenderFns } from "./faq.vue?vue&type=template&id=64972b7c&scoped=true&"
import script from "./faq.vue?vue&type=script&lang=js&"
export * from "./faq.vue?vue&type=script&lang=js&"
import style0 from "./faq.vue?vue&type=style&index=0&lang=css&"
import style1 from "./faq.vue?vue&type=style&index=1&id=64972b7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64972b7c",
  null
  
)

export default component.exports